import script from "./TableColumnSearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableColumnSearch.vue?vue&type=script&setup=true&lang=ts"

import "./TableColumnSearch.vue?vue&type=style&index=0&id=5b8f0938&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b8f0938"]])

export default __exports__